/*
 * @Author: bianbinbin
 * @Date: 2024-03-04 10:31:29
 * @LastEditors: bianbinbin
 * @LastEditTime: 2024-05-21 12:50:33
 * @PageTitle: 页面...
 * @Description: 描述...
 * @FilePath: /ejx-web/src/router/module/terminalInquiry.js
 */
const terminalInquiry = r =>
  require.ensure([], () => r(require('@/views/terminalInquiry/terminalInquiry.vue'), 'terminalInquiry'))
const moreInfo = r => require.ensure([], () => r(require('@/views/terminalInquiry/moreInfo.vue'), 'moreInfo'))
const allUtils = r => require.ensure([], () => r(require('@/views/terminalInquiry/allUtils.vue'), 'allUtils'))
const fightList = r => require.ensure([], () => r(require('@/views/terminalInquiry/fightList.vue'), 'fightList'))
const router = [
  {
    path: '/terminalInquiry',
    name: 'terminalInquiry',
    meta: {
      title: '航站查询'
    },
    component: terminalInquiry
  },
  {
    path: '/moreInfo',
    name: 'moreInfo',
    meta: {
      title: '航站查询'
    },
    component: moreInfo
  },
  {
    path: '/allUtils',
    name: 'allUtils',
    meta: {
      title: '我司配备工具'
    },
    component: allUtils
  },
  {
    path: '/fightList',
    name: 'fightList',
    meta: {
      title: ''
    },
    component: fightList
  }
]

export default router
